const state = {
    me: null,
}

export default state
